import { useEffect, useState } from "react";
import clsx from "clsx";
import FaqItem from "./FaqItem";
import { useLocale } from "hooks";
// import HtmlParser from "html-react-parser";

const FaqParentItem = ({ parent, title, index }) => {
  const [open, setOpen] = useState(false);
  const [openedChild, setOpendChild] = useState<number>(-1);
  const { isRTL } = useLocale();

  useEffect(() => {
    return () => {
      setOpendChild(-1);
    }
  }, [])

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleChildToggle = (index: number) => () => {
    setOpendChild(prev => prev === index ? -1 : index)
  }

  const hasCategory = Number.isNaN(+title);
  if (hasCategory)
    return (
      <div>
        <h3
          onClick={handleToggle}
          className={clsx(
            "tw-text-[#344456] tw-text-[14px] tw-text-[14px] xxxl:tw-text-[21.33px] tw-cursor-pointer tw-flex tw-items-center tw-py-5 tw-border-solid tw-border-[#E5E9F4] tw-border-x-0 tw-border-b-0",
            { "tw-border-t": index !== 0, "tw-border-t-0": index === 0 }
          )}
        >
          {open ? (
            <svg
              width="14"
              height="2"
              viewBox="0 0 14 2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 2H0V0H14V2Z" fill="#344456" />
            </svg>
          ) : (
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="#344456" />
            </svg>
          )}
          <span className={clsx({ "tw-mr-4": isRTL, "tw-ml-4": !isRTL })}>
            {title}
          </span>
        </h3>
        {open && (
          <div className="tw-mt-5 tw-transition-all">
            <div>
              {parent.map((el, j) => (
                <FaqItem
                  key={el.id}
                  item={el}
                  question={el.question}
                  answer={
                    // HtmlParser(el.answer)
                    <div dangerouslySetInnerHTML={{ __html: el.answer }}></div>
                  }
                  onToggle={handleChildToggle(el.id)}
                  open={openedChild === el.id}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );

  return parent?.map?.((item) => (
    <FaqItem
      key={item.id}
      question={item.question}
      answer={
        // HtmlParser(item.answer)
        <div dangerouslySetInnerHTML={{ __html: item.answer }}></div>
      }
      onToggle={handleChildToggle(item.id)}
      open={openedChild === item.id}
    />
  ));
};

export default FaqParentItem;
